import general from './general';
import { locomotivePageInit } from './functions';

const projectsPage = {
    init: function() {
        document.addEventListener('DOMContentLoaded', () => {
            this.projectsFrameSlides();
            locomotivePageInit();
        });
    },

    projectsFrameSlides: function() {
        if($('.projects-page__scene').length === 0) return;
        var slideLength = $('.projects-page__scene-item').length,
            slideCounter = 0,
            timeOut = 3000,
            intervalFunction = null;

            frameUpdate();

            intervalFunction = setInterval(function() {
                frameUpdate();
            }, timeOut);

        // $(document).on('projectsSliderStart', function() {
        //     intervalFunction = setInterval(function() {
        //         frameUpdate();
        //     }, timeOut);
        // });

        // $(document).on('projectsSliderStop', function() {
        //     clearInterval(intervalFunction);
        // });

        function frameUpdate() {
            var currentItem = $(`.projects-page__scene-item:eq(${slideCounter})`);
            $('.projects-page__scene-item').removeClass('show');
            currentItem.addClass('show');
            $('.projects-page__scene-frame-btn').attr('href', currentItem.data('link'));
            if (slideCounter === slideLength - 1) {
                slideCounter = 0;
            } else {
                slideCounter++;
            }
        }
    },
};

general.init();
projectsPage.init();
